import ELRMileAndChain from "../ELRMileAndChain";
import GenericPositionalSystem from "./GenericPositionalSystem";
import IrishRailPositionalSystem from "./IrishRailPositionSystem";
import MBTAPositionalSystem from "./MBTAPositionalSystem";
import NYNJPATHPositionalSystem from "./NYNJPATHPositionalSystem";
import NorthernIrishPositionalSystem from "./NorthernIrishPositionalSystem";
import SEPTARegionalPositionalSystem from "./SEPTARegionalPositionalSystem";
import SEPTAMetroPositionalSystem from "./SEPTAMetroPositionalSystem";
import LondonUndergroundPositionalSystem from "./LondonUndergroundPositionalSystem";
import QueenslandRailPositionalSystem from "./QueenslandRailPositionalSystem";

function custom_elr_type(system_id, simpleName) {
    return {
        ID: system_id,
        simpleName,
        handlerClass: ELRMileAndChain,
        create: (route, position, subposition, sources = []) => new ELRMileAndChain(system_id, route, position, subposition, false, sources),
        from_fields: (display_format, fields, datum_offsets) => ELRMileAndChain.from_fields(system_id, display_format, fields, datum_offsets),
        from_search: (fields) => ELRMileAndChain.from_search(system_id, fields),
    };
}

function custom_irish_position_type(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: IrishRailPositionalSystem,
        create: (route, position, subposition, sources = []) => new IrishRailPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields, datum_offsets) => IrishRailPositionalSystem.from_fields(systemID, display_format, fields, datum_offsets),
    };
}

function custom_generic_position_type(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: GenericPositionalSystem,
        create: (route, position, subposition, sources = []) => new GenericPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => GenericPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_mbta_position_type(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: MBTAPositionalSystem,
        create: (route, position, subposition, sources = []) => new MBTAPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => MBTAPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_nynjpath_position_type(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: NYNJPATHPositionalSystem,
        create: (route, position, sources = []) => new NYNJPATHPositionalSystem(systemID, route, position, sources),
        from_fields: (display_format, fields) => NYNJPATHPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_northern_irish_position_type(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: NorthernIrishPositionalSystem,
        create: (route, position, subposition, sources = []) => new NorthernIrishPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => NorthernIrishPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_septa_regional_positioning_system(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: SEPTARegionalPositionalSystem,
        create: (route, position, subposition, sources = []) => new SEPTARegionalPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => SEPTARegionalPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_septa_metro_positioning_system(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: SEPTAMetroPositionalSystem,
        create: (route, position, subposition, sources = []) => new SEPTAMetroPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => SEPTAMetroPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_london_underground_positioning_system(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: LondonUndergroundPositionalSystem,
        create: (route, position, subposition, sources = []) => new LondonUndergroundPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => LondonUndergroundPositionalSystem.from_fields(systemID, display_format, fields),
    };
}

function custom_queensland_rail_positioning_system(systemID, simpleName) {
    return {
        ID: systemID,
        simpleName,
        handlerClass: QueenslandRailPositionalSystem,
        create: (route, position, subposition, sources = []) => new QueenslandRailPositionalSystem(systemID, route, position, subposition, sources),
        from_fields: (display_format, fields) => QueenslandRailPositionalSystem.from_fields(systemID, display_format, fields),
        from_search: (fields) => QueenslandRailPositionalSystem.from_search(systemID, fields),
    };
}

const RouteCoordinateSystems = [
    custom_elr_type("ELR Mile & Chain", "ELR"),
    custom_irish_position_type("Irish Rail", "Irish Rail"),
    custom_mbta_position_type("MBTA", "MBTA"),
    custom_generic_position_type("Generic", "Generic"),
    custom_nynjpath_position_type("NYNJPATH", "PATH"),
    custom_northern_irish_position_type("Translink", "Translink"),
    custom_septa_regional_positioning_system("septaregional", "septaregional"),
    custom_septa_metro_positioning_system("SEPTA", "SEPTA"),
    custom_london_underground_positioning_system("London Underground", "TFL Tube"),
    custom_queensland_rail_positioning_system("Queensland Rail", "Queensland Rail"),
];

export default RouteCoordinateSystems;
